import { createModel } from "@/util/ModelUtil";
import LectureModel from "@/service/model/lecture/LectureModel";
import MyLectureModel from "@/service/model/myLecture/MyLectureModel";
import OrganizationModel from "@/service/model/organization/OrganizationModel";

export default class LectureInfoModel {
  constructor(
    public lecture: Lecture = new LectureModel(),
    public myLecture: MyLecture = new MyLectureModel(),
    public organization: Organization = new OrganizationModel()
  ) {}

  public static create(lectureInfo?: LectureInfo): LectureInfoModel {
    return createModel<LectureInfoModel>(LectureInfoModel, lectureInfo);
  }
}
